import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { LocationStrategy, PlatformLocation, Location } from '@angular/common';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { TokenService } from './shared/services/token-service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxExtendedPdfViewerModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
})
export class App implements OnInit {

  constructor(
    public location: Location,
    private tokenService: TokenService,
    private platformLocation: PlatformLocation,
  ) { }

  ngOnInit() {
    // 監聽 URL 變化，以便檢測到新 token 時能夠重新登入
    this.setupUrlChangeListener();
  }

  private setupUrlChangeListener(): void {
    // 使用 PlatformLocation 的 onHashChange 事件來監聽 hash 變化
    (this.platformLocation as any).onHashChange(() => {
      console.log('[App] Hash 變化檢測到');
      this.checkUrlForToken();
    });
  }

  private checkUrlForToken(): void {
    const hash = window.location.hash;
    console.log('[App] 檢查 URL 中是否有 token，hash:', hash);
    
    if (hash.includes('?token=')) {
      try {
        const hashParts = hash.split('?');
        const queryString = hashParts[1];
        if (queryString) {
          const params = new URLSearchParams(queryString);
          const urlToken = params.get('token');
          
          if (urlToken) {
            const currentToken = this.tokenService.getLoginToken();
            
            if (currentToken !== urlToken) {
              console.log('[App] ✅ 檢測到新 Token，正在切換用戶...');
              this.tokenService.setLogonToken(urlToken);
              
              // 清理 URL
              const cleanHash = hashParts[0];
              window.history.replaceState({}, '', window.location.pathname + cleanHash);
              console.log('[App] 🔧 已清理 URL 中的 Token 參數');
              
              // 延遲後重新載入頁面以確保 Cookie 已設置並頁面可以讀取新 Token
              setTimeout(() => {
                console.log('[App] 重新載入頁面以更新使用者信息...');
                window.location.reload();
              }, 500);
            } else {
              console.log('[App] Token 相同，無需切換');
            }
          }
        }
      } catch (error) {
        console.error('[App] 處理 URL token 時出錯:', error);
      }
    }
  }
}
